var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{staticClass:"v-application-bgarage"}),_c('bw-spinner',{ref:"gSpinner",attrs:{"is-global":true,"visible":_vm.gSpinnerVisible},on:{"update:visible":function($event){_vm.gSpinnerVisible=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }